import RosterBackendService from "./RosterBackendService";
import { BeableAdminCreateRequest } from "@beable/roster-backend-client-v1";


async function getBeableAdmins(){
  const beableAdminsResponse = await RosterBackendService.getBeableAdmins();
  if (beableAdminsResponse.isOk() && beableAdminsResponse.value) {
    return beableAdminsResponse.value;
  }

  return null;
}

async function createBeableAdmin(req: BeableAdminCreateRequest){
  const beableAdminsResponse = await RosterBackendService.createBeableAdmin(req);
  if (beableAdminsResponse.isOk() && beableAdminsResponse.value) {
    return beableAdminsResponse.value;
  }

  return null;
}

async function deleteBeableAdmin(id: string){
  const beableAdminsResponse = await RosterBackendService.deleteBeableAdmin(id);
  if (beableAdminsResponse.isOk() && beableAdminsResponse.value) {
    return beableAdminsResponse.value;
  }

  return null;
}

export default {
  getBeableAdmins,
  createBeableAdmin,
  deleteBeableAdmin
}
